import Image from 'next/image';

import { useFormatter } from 'next-intl';

import { ApiSummaryProject } from '@/lib/core-api/types';

import {
  smallProject,
  smallProjectAmount,
  smallProjectDescription,
  smallProjectIllustration,
  smallProjectIllustrationImg,
  smallProjectTitle,
} from './index.css';

type SmallProjectCardProps = {
  project: ApiSummaryProject;
};

export function SmallProjectCard({ project }: SmallProjectCardProps) {
  const format = useFormatter();

  return (
    <section className={smallProject}>
      <section role={'presentation'} className={smallProjectIllustration}>
        {project.bgImgUrl !== null && (
          <Image
            className={smallProjectIllustrationImg}
            role="presentation"
            alt={project.projectName}
            src={project.bgImgUrl}
            width={310}
            height={470}
          />
        )}
      </section>
      <span className={smallProjectAmount}>
        {format.number(project.amountInvested, {
          style: 'currency',
          useGrouping: 'always',
          currency: 'EUR',
        })}{' '}
        levés
      </span>
      <section
        className={smallProjectTitle}
        dangerouslySetInnerHTML={{
          __html: project.projectName ?? '',
        }}
      />
      <section
        className={smallProjectDescription}
        dangerouslySetInnerHTML={{
          __html: project.smallDescription ?? '',
        }}
      />
    </section>
  );
}
